// extracted by mini-css-extract-plugin
module.exports = {"background-white":"BaseLayout_background-white__Pvsmj","background-gray":"BaseLayout_background-gray__2A-gp","fixedTop":"BaseLayout_fixedTop__2aOiW"};